// vue-router导航守卫
export default function ({
  // isHMR,
  app,
  store
  // route,
  // params,
  // error,
  // redirect,
  // req
}) {
  app.router.beforeEach(async (to, from, next) => {
    if (/\/seller-center\//.test(to.fullPath)) {
      if (/seller-center\/application\/store\/(view|edit)\//.test(to.path) && !to.query?.layout) {
        // empty
      } else {
        if (!store.state.storeInfo?.settlementAccount) {
          await store.dispatch('initStoreInfo')
        }
      }
    }

    if (Number(to.query.code) === 1001) {
      // token 失效时清理所有 cookie 和登陆状态， 防止产生重复跳转的问题
      store.commit('logOut')
      app.$cookies.removeAll({ path: '/' })
      app.$cookies.removeAll({ path: '/seller-center' })
      // 防止登录后重定向到login页面
      const path = from.path.name === 'login' ? to.path : `/login?redirect=${from.path}`
      next(path)
    } else {
      // 重定向到login页面时,跳转到home页面
      const toPath = to.query?.redirect === '/login' && store.state.isLogin
      if (toPath) {
        return next('/seller-center/home')
      }

      const createGoods = to.name === 'seller-center-goods-new' && to.query.type !== 'editor'
      const { settlementAccount } = store.state.storeInfo

      createGoods && !settlementAccount?.bankName ? next(false) : next()
    }
  })
}
